/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Country_Of_OriginInputs */

const en_field_country_of_origin = /** @type {(inputs: Field_Country_Of_OriginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country of origin`)
};

/**
* | output |
* | --- |
* | "Country of origin" |
*
* @param {Field_Country_Of_OriginInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_country_of_origin = /** @type {((inputs?: Field_Country_Of_OriginInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Country_Of_OriginInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_country_of_origin(inputs)
});